/* eslint-disable no-underscore-dangle */
import { makeAutoObservable } from 'mobx';
import { shd } from '@shd/jslib/models';

export interface User {
  nameFirst?: string | undefined;
  nameLast?: string | undefined;
  email?: string | undefined;
  phoneList?: string[] | [];
  authToken?: string | null;
  appNotificationsEnabled: boolean | undefined;
}

class UserStore {
  firstName: string | null = null;
  lastName: string | null = null;
  email: string | null = null;
  phoneNumber?: string | null = null;
  authToken?: string | null = null;
  appNotificationsEnabled: boolean = false;
  isLoggedIn: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  public setUserV2(
    user: shd.User,
    authToken: string | null = null,
    isLoggedIn: boolean = false
  ): void {
    this.firstName = user.nameFirst || null;
    this.lastName = user.nameLast || null;
    this.email = user.email || null;
    this.phoneNumber = user.phoneList?.[0] || null;
    this.authToken = authToken || null;
    this.appNotificationsEnabled = user.appNotificationsEnabled || false;
    this.isLoggedIn = isLoggedIn;
  }

  public getDisplayName(): string {
    return `${this.firstName || ''} ${this.lastName || ''}`.trim();
  }

  public fetchAuthToken(): string | null {
    return this.authToken || null;
  }
}

export default UserStore;
